import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dateBegin: '',
  numberContract: '',
  percent: '',
  parilifepercent: '',
  dateContract: '',
  pay_month: '',
  stringDateBegin: '',
  stringDateContract: ''
};

export const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    setStringDateContract: (state, action) => {
      state.stringDateContract = action.payload
    },
    setStringDateBegin: (state, action) => {
      state.stringDateBegin = action.payload
    },
    setPariLifePercent: (state, action) => {
      state.parilifepercent = action.payload
    },
    setPercent: (state, action) => {
      state.percent = action.payload
    },
    setDateContract: (state, action) => {
      state.dateContract = action.payload
    },
    setPayMonth: (state, action) => {
      state.pay_month = action.payload
    },
    setDateBegin: (state, action) => {
      state.dateBegin = action.payload
    },
    setNumberContract: (state, action) => {
      state.numberContract = action.payload
    }  
  },
});

export const { 
  setPariLifePercent,
  setStringDateBegin,
  setStringDateContract,
  setDateContract,
  setPayMonth,
  setPercent,
  setDateBegin,
  setNumberContract
} = contractSlice.actions;

export const selectDateBegin = (state) => state.contract.dateBegin;
export const selectNumberContract = (state) => state.contract.numberContract;

export const selectDateContract = (state) => state.contract.dateContract;
export const selectPayMonth = (state) => state.contract.pay_month;
export const selectPercent = (state) => state.contract.percent;
export const selectPariLifePercent = (state) => state.contract.parilifepercent;

export const selectStringDateBegin = (state) => state.contract.stringDateBegin;
export const selectStringDateContract = (state) => state.contract.stringDateContract;

export default contractSlice.reducer;
